import { Play, Pause, Clock, Zap } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/Card';
import type { MetricasIAWhatsApp } from '@/types';

interface MetricasHeaderProps {
  metricas?: MetricasIAWhatsApp;
  isLoading: boolean;
}

export function MetricasHeader({ metricas, isLoading }: MetricasHeaderProps) {
  const items = [
    {
      label: 'Conversas Ativas',
      value: metricas?.ia_ativa ?? 0,
      icon: Play,
      color: 'text-ds-success',
      bgColor: 'bg-ds-success/10',
      description: 'IA respondendo normalmente'
    },
    {
      label: 'IA Desligada',
      value: metricas?.ia_desligada ?? 0,
      icon: Pause,
      color: 'text-ds-danger',
      bgColor: 'bg-ds-danger/10',
      description: 'Atendimento humano ativo'
    },
    {
      label: 'Reativações 24h',
      value: metricas?.reativacoes_24h ?? 0,
      icon: Zap,
      color: 'text-ds-warning',
      bgColor: 'bg-ds-warning/10',
      description: 'Reativações enviadas hoje'
    },
    {
      label: 'Taxa Resposta 7d',
      value: `${metricas?.taxa_resposta_7d ?? 0}%`,
      icon: Clock,
      color: 'text-ds-info',
      bgColor: 'bg-ds-info/10',
      description: 'Taxa de resposta semanal'
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {items.map((item) => (
        <Card key={item.label} className="bg-ds-surface2 border-ds-border">
          <CardContent className="p-4">
            <div className="flex items-center gap-3">
              <div className={`p-2 rounded-lg ${item.bgColor}`}>
                <item.icon className={`h-5 w-5 ${item.color}`} />
              </div>
              <div>
                <p className="text-xs text-ds-text-secondary">{item.label}</p>
                <p className="text-xl font-bold text-ds-text-primary">
                  {isLoading ? '-' : item.value}
                </p>
              </div>
            </div>
            <p className="text-xs text-ds-text-secondary mt-2">{item.description}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
